import React from 'react';
import ClientPaymentsSearchParams from './ClientPaymentsSearchParams';
import TabOfDataTable from '../../../Elements/DataTable/TabOfDataTable';
import ClientPaymentItem from '../../../Domain/ClientPaymentItem';
import ClientPaymentService from '../../../Services/ClientPaymentService';
import ShownPanelsEnum from '../../../Enums/ShownPanelsEnum';
import ButtonTypeEnum from '../../../Enums/ButtonTypeEnum';
import ButtonColorsEnum from '../../../Enums/ButtonColorsEnum';
import IconPositionEnum from '../../../Enums/IconPositionEnum';
import CrudTypesEnum from '../../../Enums/CrudTypesEnum';
import FigmaButtonRow from '../../../Elements/FigmaButtonRow';
import GeneralEditWizzardBase from '../../../Elements/GeneralEditWizzard/GeneralEditWizzardBaseFigma';
import CreateClientPaymentWindowDescription from './CreateClientPaymentWindowDescription';
import CreateClientPaymentItem from '../../../Domain/CreateClientPaymentItem.ts';
import ErrorMessage from '../../../Elements/ErrorMessage';
import CreatePaymentRefundItem from '../../../Domain/CreatePaymentRefundItem';
import CreateClientPaymentRefundWindowDescription from './CreateClientPaymentRefundWindowDescription';

export default class ClientPaymentsAdmin extends React.Component
{
  static defaultProps = {
    type: 'all',
  };

  constructor (props)
  {
    super(props);
    this.state = {
      allItemsInTheSearchSetAreSelected: false,
      itemList: [],
      numberOfElementsInTheTable: 0,
      shownPanel: ShownPanelsEnum.None,
      searchItem: new ClientPaymentsSearchParams(),
    };

    this.startSearch = this.startSearch.bind(this);
    this.refresh = this.refresh.bind(this);
    ClientPaymentItem.refundFunction = this.refundFunction.bind(this);
    ClientPaymentItem.reverseFunction = this.reverseFunction.bind(this);
    this.callReverseFunction = this.callReverseFunction.bind(this);
    this.openPaymentsApplied = this.openPaymentsApplied.bind(this);
  }

  refresh (refresh)
  {
    if (refresh)
    {
      this.setState({ shownPanel: ShownPanelsEnum.None, searchItem: { ...this.state.searchItem } });
    } else this.setState({ shownPanel: ShownPanelsEnum.None });
  }

  renderOnePanel = (panelId, content) => (this.state.shownPanel === panelId ? content : null);

  showPanel (panelId)
  {
    panelId = panelId === this.state.shownPanel ? ShownPanelsEnum.None : panelId;
    this.setState({ shownPanel: panelId });
  }

  componentDidMount ()
  {
    const searchItem = { ...this.state.searchItem };
    searchItem.PaymentListType = this.props.type;
    if (searchItem.PaymentListType !== this.state.searchItem.PaymentListType) this.setState({ searchItem });
  }

  componentDidUpdate ()
  {
    const searchItem = { ...this.state.searchItem };
    searchItem.PaymentListType = this.props.type;
    if (searchItem.PaymentListType !== this.state.searchItem.PaymentListType) this.setState({ searchItem });
  }

  refundFunction (selectedId, paymentItem)
  {
    const selectedItem = new CreatePaymentRefundItem();
    selectedItem.ClientPaymentId = paymentItem.CpId;
    selectedItem.Amount = paymentItem.CpBalance;
    this.setState({
      selectedItem,
      shownPanel: ShownPanelsEnum.Refund,
    });
  }

  reverseFunction (selectedId, selectedItem)
  {
    ErrorMessage.SetWarningWithComment(
      `Reversing a client payment is permanent and cannot be undone. (ID: ${selectedItem.CpId}). Are you sure?`,
      'Comment:',
      (comment) =>
      {
        this.callReverseFunction(selectedItem.CpId, comment);
      },
      'Yes',
      'No'
    );
  }

  callReverseFunction (selectedId, comment)
  {
    ClientPaymentService.ReversePayment(selectedId, comment)
      .then((result) =>
      {
        if (result.error)
        {
          ErrorMessage.SetErrorMessage(result.error);
        } else
        {
          ErrorMessage.SetNotification('Payment reversed.');
          ErrorMessage.SetLoading(false);
          this.refresh(true);
        }
      })
      .catch((error) =>
      {
        ErrorMessage.SetErrorMessage('CPA97', error);
        ErrorMessage.SetLoading(false);
      });
    ErrorMessage.SetLoading(true);
  }

  startSearch (searchItem)
  {
    this.setState({ searchItem: { ...searchItem } });
  }

  getPaymentIds ()
  {
    return this.state.itemList
      .filter((x) => x.Selected === true)
      .map((x) => x.CpId)
      .join(',');
  }

  getNumberOfSelectedElements ()
  {
    return this.state.itemList.filter((x) => x.Selected === true).length;
  }

  openPaymentsApplied ()
  {
    window.open(
      `/finance_clientpayment/search?PaymentIdsString=${encodeURIComponent(this.getPaymentIds())}&tab=3`,
      '_blank'
    );
  }

  renderButtonsAndPanels ()
  {
    return (
      <div>
        <FigmaButtonRow
          buttons={[
            {
              type: ButtonTypeEnum.NormalNormal,
              color: ButtonColorsEnum.Common,
              iconPosition: IconPositionEnum.None,
              label: 'Applied Payments',
              onClick: this.openPaymentsApplied,
              tooltip: 'Applied Payments',
              disabled: this.getNumberOfSelectedElements() === 0,
            },
            {
              type: ButtonTypeEnum.NormalIconOnly,
              color: ButtonColorsEnum.Primary,
              iconPosition: IconPositionEnum.Center,
              iconName: 'fa-solid fa-plus-circle',
              onClick: () => this.setState({ shownPanel: ShownPanelsEnum.AddNewItem }),
              tooltip: 'New Payment',
              roleKey: 'clientpayment_create',
            },
          ]}
        />
        {this.renderPanels()}
      </div>
    );
  }

  renderPanels ()
  {
    return (
      <div>
        {this.renderOnePanel(
          ShownPanelsEnum.AddNewItem,
          <GeneralEditWizzardBase
            crudType={CrudTypesEnum.Create}
            editedItem={new CreateClientPaymentItem()}
            clickOnCancel={() => this.setState({ shownPanel: ShownPanelsEnum.None })}
            clickOnSave={() => this.refresh(true)}
            windowDescription={CreateClientPaymentWindowDescription}
            errorCode='CPA93'
          />
        )}
        {this.renderOnePanel(
          ShownPanelsEnum.Refund,
          <GeneralEditWizzardBase
            crudType={CrudTypesEnum.Create}
            editedItem={this.state.selectedItem}
            clickOnCancel={() => this.setState({ shownPanel: ShownPanelsEnum.None })}
            clickOnSave={() => this.refresh(true)}
            windowDescription={CreateClientPaymentRefundWindowDescription}
            errorCode='CPA151'
          />
        )}
      </div>
    );
  }

  render ()
  {
    return (
      <div className='contentwrapper'>
        {this.renderButtonsAndPanels()}
        <TabOfDataTable
          type={ClientPaymentItem}
          shownPanel={this.state.shownPanel}
          serviceFunction={ClientPaymentService.GetPaymentsBySearching}
          convertDBItemsFunction={ClientPaymentService.ConvertPaymentDBItems}
          searchParamsType={ClientPaymentsSearchParams}
          showSearchStrip={true}
          clickOnStartSearch={this.startSearch}
          searchItem={this.state.searchItem}
          orderBy='CpPaymentDate'
          orderDirection='Desc'
          singleSearchLine={true}
          singleSearchLinePlaceholder='Search in client id, payment id, client name or type...'
          errorCode='CPA180'
          changeOfItemListFunction={(itemList, numberOfElementsInTheTable) =>
            this.setState({ itemList, numberOfElementsInTheTable })
          }
          changeOfAllItemsAreSelectedFunction={(allItemsInTheSearchSetAreSelected) =>
          {
            this.setState({ allItemsInTheSearchSetAreSelected });
          }}
          isSelectAllDisabled={true}
        />
      </div>
    );
  }
}
